<template>
    <div class="integration">
        <div style="display: flex; justify-content: space-between; align-items: baseline">
            <PageTitle main="Integrações"/>
            <b-button v-show="!modalActive" id="btn-principal" variant="success" @click="addIntegration()" size="lgx" class="mb-2" v-if="user.int_adi">  
                <i class="fa fa-plus"></i> Adicionar
            </b-button>
        </div>

        <div id="pageGrid" v-show="!modalActive">
            <div class="integrations-wrapper">
                <div v-for="integration in integrations" :key="integration.integracao_id" :class="integration.status === 'Ativo' ? '' : 'inactive-card'">
                    <div class="integration-card-header">
                        <svg v-if="!integration.nm_plataforma === 'Greenn'" width="50" height="50" xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 250 250">
                            <g>
                                <path fill-rule="evenodd" clip-rule="evenodd" fill="#464E51" d="M127.398,9.845c5.404,0,10.717,0.39,15.917,1.129   c-47.428,1.84-86.374,36.799-94.344,82.397c-0.567,0.436-1.131,0.872-1.689,1.309c-9.454,7.386-22.005,18.475-32.13,30.96   c-0.035-1.159-0.06-2.32-0.06-3.488C15.092,60.137,65.384,9.845,127.398,9.845L127.398,9.845z M48.219,122.825   c-5.324,4.734-10.366,9.776-14.813,15.065c-4.499,5.35-10.319,13.353-12.171,20.96c1.659,4.798,3.632,9.447,5.898,13.926   c0.468,0.176,0.962,0.351,1.485,0.527l0.411,0.139c5.525-11.251,14.354-21.531,23.854-30.33   C50.652,136.626,49.072,129.838,48.219,122.825L48.219,122.825z M63.295,164.576c3.503,5.444,7.523,10.522,11.987,15.172   c-9.034,8.97-16.032,18.747-18.43,28.412c-1.077-0.337-2.091-0.726-3.035-1.172c-2.366-2.054-4.64-4.208-6.825-6.45   c-0.838-1.792-1.288-3.888-1.288-6.329c0-8.886,7.652-18.894,13.315-25.15C60.394,167.54,61.823,166.045,63.295,164.576   L63.295,164.576z M91.896,193.667c15.839,10.587,34.875,16.762,55.353,16.762c35.617,0,66.875-18.678,84.528-46.766   c-16.512,41.472-57.025,70.795-104.378,70.795c-16.104,0-31.413-3.398-45.26-9.506c-2.44-2.242-3.926-4.988-3.926-8.353   C78.213,208.6,84.712,200.356,91.896,193.667z"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" fill="#ED1B24" d="M147.248,20.292c49.9,0,90.367,40.467,90.367,90.367   c0,49.899-40.467,90.366-90.367,90.366c-6.27,0-12.39-0.639-18.3-1.855c2.246,0.187,4.515,0.288,6.809,0.288   c44.708,0,80.964-36.257,80.964-80.965s-36.256-80.965-80.964-80.965c-32.189,0-59.989,18.797-73.038,46.008   c-0.71,0.472-1.418,0.947-2.121,1.425C71.672,47.576,106.276,20.292,147.248,20.292z"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" fill="#ED1B24" d="M156.192,84.791c9.324,0,16.887,7.563,16.887,16.888   s-7.563,16.887-16.887,16.887c-5.565,0-10.502-2.692-13.578-6.847c-34.647,9.448-101.354,52.875-101.354,82.49   c0,9.892,5.966,15.764,14.82,18.36c-0.086,0.882-0.131,1.761-0.131,2.637c0,3.484,0.49,6.897,1.517,10.145   c-18.354,0.742-29.859-11.136-29.859-28.455c0-45.975,78.781-89.563,112.015-98.484C141.145,90.65,147.985,84.791,156.192,84.791   L156.192,84.791z M156.192,94.377c-4.032,0-7.302,3.27-7.302,7.302s3.27,7.302,7.302,7.302c4.031,0,7.302-3.27,7.302-7.302   S160.224,94.377,156.192,94.377z"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" fill="#ED1B24" d="M110.225,54.495c9.325,0,16.888,7.563,16.888,16.887   c0,9.325-7.563,16.888-16.888,16.888c-4.244,0-8.123-1.567-11.09-4.154c-35.651,16.099-82.936,54.225-82.936,79.344   c0,8.695,4.012,11.692,10.997,14.055c-1.765,4.31-3.015,8.748-3.619,13.287c-13.535-2.205-21.547-11.844-21.547-26.461   c0-30.599,51.867-75.47,91.313-92.652l-0.003-0.306C93.338,62.058,100.9,54.495,110.225,54.495L110.225,54.495z M110.225,64.08   c-4.032,0-7.302,3.271-7.302,7.302c0,4.032,3.27,7.302,7.302,7.302c4.032,0,7.302-3.27,7.302-7.302   C117.526,67.351,114.257,64.08,110.225,64.08z"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" fill="#ED1B24" d="M147.313,135.46c9.324,0,16.887,7.563,16.887,16.888   c0,9.324-7.563,16.887-16.887,16.887c-5.752,0-10.833-2.878-13.883-7.271h-0.001c-19.886,9.016-59.659,32.129-59.659,54.636   c0,17.737,28.053,22.294,47.932,22.572c-34.927,12.633-61.308,0.095-61.308-23.966c0-27.025,48.361-58.344,70.451-66.614h0.001   C132.553,141.073,139.278,135.46,147.313,135.46L147.313,135.46z M147.313,145.046c-4.032,0-7.302,3.27-7.302,7.302   s3.27,7.302,7.302,7.302c4.031,0,7.301-3.27,7.301-7.302S151.344,145.046,147.313,145.046z"/>
                            </g>
                        </svg>
                        <img v-else src="@/assets/greenn50.png" alt="logo da greenn">
                        <div>
                            <span>{{ integration.nm_integracao }}</span>
                            <span>Integração com: {{ integration.nm_plataforma }}</span>
                        </div>
                    </div>
                    <span class="integration-company-name">{{ integration.nm_empresa }}</span>
                    <div class="integration-data">
                        <span>
                            <span v-if="integration.emissao_automatica === 'Não'" style="color: var(--red); font-weight: 600; width: 14px;">✖</span>
                            <i v-else style="color: var(--greenn);" class="fa fa-check"></i>
                            Emissão automática
                        </span> <br>
                        <span>
                            <span v-if="integration.integra_webhook === 'Não'" style="color: var(--red); font-weight: 600; width: 14px;">✖</span>
                            <i v-else style="color: var(--greenn);" class="fa fa-check"></i>
                            Webhook
                        </span>
                    </div>
                    <div class="integration-buttons">
                        <button @click="loadIntegration(integration)">  
                            <i class="fa fa-pencil"></i> Editar
                        </button>
                        <button @click="removeIntegration(integration)" v-if="user.int_exc">   
                            <i class="fa fa-trash"></i> Deletar
                        </button>
                    </div>
                </div>
            </div>
            <b-pagination class="customPagination mt-4" size="md" v-model.trim="page" :total-rows="count" :per-page="limit" />
        </div>
        
        <b-modal ref="modalRemove" hide-footer hide-header centered title="Confirmação!">
            <p class="my-4" style="text-align: center;">Deseja realmente excluir esta integração?</p>
            <template v-slot:modal-footer="{ hideRemove , confirmeRemove }">
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="danger" class="mr-2"
                            @click="confirmeRemove()">Excluir 
                        </b-button>
                        <b-button class="mr-2"
                            @click="hideRemove()">Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>       

        <div id="pageEdition" v-show="modalActive">
            <b-card :header="tituloModal"> 
                <b-form @submit.prevent="submit">
                    <div class="title-integ">
                        <p>Dados da Integração</p>
                    </div>

                    <input id="usuario_id" type="hidden" v-model.trim="this.$store.state.user.userid"> 
                    <input id="integration-id" type="hidden" v-model.trim="integration.integracao_id"> 
                    <input id="integration-guid" type="hidden" v-model.trim="integration.guid"> 

                    <b-row>
                        <b-col md="4" sm="12">
                            <b-form-group label="*Nome da Integração" label-for="integration-nm_integracao">
                                <b-form-input 
                                    type="text" 
                                    id="integration-nm_integracao" 
                                    name="integration-nm_integracao"
                                    ref="integration-nm_integracao"
                                    v-focus
                                    v-model.trim="integration.nm_integracao" 
                                    :class="{ 'form-control is-invalid' : $v.integration.nm_integracao.$error }"
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))"
                                    maxlength="100"
                                    placeholder="Informe o nome da integração">
                                </b-form-input>
                            </b-form-group>
                        </b-col>

                        <!--
                        <b-col md="3" sm="12">
                            <b-form-group label="*Inicio da Integração" label-for="integration-dt_inicial_integracao">
                                <b-form-input 
                                    type="text"
                                    id="integration-dt_inicial_integracao" 
                                    name="integration-dt_inicial_integracao" 
                                    ref="integration-dt_inicial_integracao"
                                    v-model.trim="integration.dt_inicial_integracao" 
                                    :class="{ 'form-control is-invalid' : $v.integration.dt_inicial_integracao.$error }"
                                    v-mask="'##/##/####'"
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))"                             
                                    placeholder="Informe data inicial">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        -->
                        <b-col md="3" sm="12">
                            <b-form-group label="*Inicio da Integração" label-for="integration-dt_inicial_integracao">
                            <DatePicker
                                id="integration-dt_inicial_integracao"
                                name="integration-dt_inicial_integracao"
                                ref="integration-dt_inicial_integracao"
                                v-model="integration.dt_inicial_integracao"
                                :class="{ 'form-control is-invalid' : $v.integration.dt_inicial_integracao.$error }"
                                :disabled="(!isInsert && !this.$store.state.user.int_edi)"
                                :editable="false"
                                format="DD/MM/YYYY"
                                placeholder="Informe data inicial"
                            />
                            </b-form-group>
                        </b-col>

                        <b-col md="5" sm="12">
                            <b-form-group label="*Empresa" label-for="integration-empresa_id">
                                <b-form-select 
                                    id="integration-empresa_id"
                                    name="integration-empresa_id"
                                    ref="integration-empresa_id"
                                    :options="companies" v-model.trim="integration.empresa_id" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))" 
                                    :class="{ 'form-control is-invalid' : $v.integration.empresa_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Plataforma" label-for="integration-plataforma_id">
                                <b-form-select 
                                    id="integration-plataforma_id"
                                    name="integration-plataforma_id"
                                    ref="integration-plataforma_id"
                                    :options="platforms" v-model.trim="integration.plataforma_id" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))" 
                                    :class="{ 'form-control is-invalid' : $v.integration.plataforma_id.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Tipo da Nota Fiscal" label-for="integration-fl_tipo_nota">
                                <b-form-select 
                                    id="integration-fl_tipo_nota"
                                    name="integration-fl_tipo_nota"
                                    ref="integration-fl_tipo_nota"
                                    v-model.trim="integration.fl_tipo_nota" :options="optTipoNota"
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))" 
                                    :class="{ 'form-control is-invalid' : $v.integration.fl_tipo_nota.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group label="*Transmitir Nota Automaticamente" label-for="integration-fl_emissao_automatica">
                                <b-form-select 
                                    id="integration-fl_emissao_automatica"
                                    name="integration-fl_emissao_automatica"
                                    ref="integration-fl_emissao_automatica"
                                    v-model.trim="integration.fl_emissao_automatica" :options="optSimNao"
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))" 
                                    :class="{ 'form-control is-invalid' : $v.integration.fl_emissao_automatica.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Status" label-for="integration-fl_status">
                                <b-form-select 
                                    id="integration-fl_status"
                                    name="integration-fl_status"
                                    ref="integration-fl_status"
                                    v-model.trim="integration.fl_status" :options="optStatus"
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))" 
                                    :class="{ 'form-control is-invalid' : $v.integration.fl_status.$error }">                                    
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <hr>
                    <div class="title-integ">
                        <p>API KEY</p>
                    </div>

                    <div style="display: flex;">
                        <b-button id="btn-principal" variant="success" @click="getGerarToken()" size="sm" style="width: 200px; border-radius: 10px 0 0 10px;">  
                            <i class="fa fa-key" style="padding: 5px;"></i>Gerar Token
                        </b-button>
                        <b-form-input 
                            style="border-radius: 0 10px 10px 0;"
                            type="text"
                            id="integration-api_key" 
                            name="integration-api_key" 
                            ref="integration-api_key" 
                            v-model.trim="integration.api_key" 
                            maxlength="100" 
                            placeholder="Token de integração para a plataforma acessar a API fiscal "
                            readonly>
                        </b-form-input>
                    </div>

                    <hr>
                    <div class="title-integ">
                        <p>WEBHOOK</p>
                    </div>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Integrar Webhook" label-for="integration-fl_integra_webhook">
                                <b-form-select 
                                    id="integration-fl_integra_webhook"
                                    name="integration-fl_integra_webhook"
                                    ref="integration-fl_integra_webhook"
                                    v-model.trim="integration.fl_integra_webhook" :options="optSimNao"
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))" 
                                    :class="{ 'form-control is-invalid' : $v.integration.fl_integra_webhook.$error }">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="10" sm="12">
                            <b-form-group v-show="integration.fl_integra_webhook && integration.fl_integra_webhook == 'S'" label="URL do Webhook" label-for="integration-url_webhook">
                                <b-form-input 
                                    type="text" 
                                    id="integration-url_webhook" 
                                    name="integration-url_webhook"
                                    ref="integration-url_webhook"
                                    v-model.trim="integration.url_webhook" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))" 
                                    maxlength="100"
                                    placeholder="URL de integração da plataforma para receber postback da API fiscal">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group v-show="integration.fl_integra_webhook && integration.fl_integra_webhook == 'S'" label="Token do Webhook" label-for="integration-token_webhook">
                                <b-form-input 
                                    type="text" 
                                    id="integration-token_webhook" 
                                    name="integration-token_webhook"
                                    ref="integration-token_webhook"
                                    v-model.trim="integration.token_webhook" 
                                    :readonly="((!isInsert) && (!this.$store.state.user.int_edi))" 
                                    maxlength="100"
                                    placeholder="Token de integração da plataforma para receber postback da API fiscal">
                                </b-form-input>
                            </b-form-group>
                        </b-col>                        
                    </b-row>

                    <div style="padding: 10px 0px 10px 0px; display: flex; justify-content: end;"> 
                        <b-button class="mr-2" style="width: 150px;"
                            @click="toggleModal">Cancelar
                        </b-button>
                        <b-button  id="btn-principal" variant="success" v-if="((isInsert) || (user.int_edi))" class="mr-2" style="width: 150px;"
                            @click="saveIntegration">Salvar 
                        </b-button>
                    </div>

                </b-form>        
            </b-card>
        </div>

    </div>  
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Modal from '../template/Modal'
///import { required, minLength } from "vuelidate/lib/validators"
import { required } from "vuelidate/lib/validators"
import formMixin from '../../config/mixinform'
import Sha256 from '../../config/sha256.js'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'

export default {
    name: 'Integracoes',
    computed: mapState(['user']),
    components: { PageTitle, Modal, DatePicker },
    mixins: [ formMixin ],

    data: function () {
        return {
            mode: 'save',
            modalActive: false,
            tituloModal: null,
            isInsert: false,            

            integration: {},
            //integration: {
            //    dt_inicial_integracao: null // Ajuste conforme necessário
            //},

            integrations: [],
            companies: [],
            platforms: [],
            
            fields: [
                { key: 'nm_integracao', label: 'Nome da Integração' },
                { key: 'nm_empresa', label: 'Empresa' },
                { key: 'nm_plataforma', label: 'Plataforma' },
                { key: 'emissao_automatica', label: 'Emissão Automática' },
                { key: 'integra_webhook', label: 'Integra Webhook' },
                { key: 'status', label: 'Status' },
                { key: 'actions', label: 'Ações', class: 'text-center' }

            ],
            page: 1,
            count: 0,
            limit: 0,

            optSimNao: [
                { value: "S", text: 'Sim' },
                { value: "N", text: 'Não' }
            ],

            optStatus: [
                { value: "A", text: 'Ativo' },
                { value: "I", text: 'Inativo' }
            ],

            optTipoNota: [
                { value: "S", text: 'Serviço (Infoproduto)' },
                { value: "P", text: 'Produto' }
            ],

            money: {
                decimal: ',',
                thousands: '.',	
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false 
            }

        }
    },

    validations: {
        integration: {
            nm_integracao: { required },
            //dt_inicial_integracao: { required, minLength: minLength(10) },
            dt_inicial_integracao: { required },
            empresa_id: { required },
            plataforma_id: { required },
            fl_tipo_nota: { required },
            fl_emissao_automatica: { required },
            fl_status: { required },
            fl_integra_webhook: { required }
        }
    },

    methods: {
        loadIntegrations() {
            axios.get(`${baseApiUrl}/integracao/usuario/${this.$store.state.user.userid}/empresas/${this.$store.state.user.empsuser}/pagina/${this.page}`)
                 .then(resp => {
                     this.integrations = resp.data.data
                     this.count = parseInt(resp.data.count)
                     this.limit = parseInt(resp.data.limit)
            })
        },

        loadCompanies() {
            axios.get(`${baseApiUrl}/usuario/empresas/` + this.$store.state.user.userid)  
                 .then(resp => {
                     this.companies = resp.data.data.map(campany => {
                         return { value: campany.empresa_id, text: campany.nm_empresa }
                     })
            })
        },

        loadPlatforms() {
            axios.get(`${baseApiUrl}/plataforma/`)  
                 .then(resp => {
                     this.platforms = resp.data.data.map(platform => {
                         return { value: platform.plataforma_id, text: platform.nm_plataforma }
                     })
            })
        },

        loadIntegration(integration, mode = 'save') {
            this.mode = mode
            this.integration = { ...integration }  

            axios.get(`${baseApiUrl}/integracao/integracao/${integration.integracao_id}`)
                 .then(resp => {
                     this.integration = resp.data.data



                     // Converter para objeto Date
                     this.integration.dt_inicial_integracao = moment(this.integration.dt_inicial_integracao, 'DD/MM/YYYY').toDate();
            })

            this.tituloModal = 'Editar Integração'
            this.toggleModal()
        },

        addIntegration() {
            this.integration = {}
            this.tituloModal = 'Adicionar Integração'
            this.toggleModal()
            this.isInsert = true           
        },

        getGerarToken() {
            // Verifica campo obrigatorio para gerar o token
            var nomeIntegracao = document.getElementById('integration-nm_integracao').value;
            if (nomeIntegracao == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar o nome da integração!'})
                document.getElementById('integration-nm_integracao').focus()
                return
            } 
            // Se ok prossegue
            var dataHora = new Date
            var texto = nomeIntegracao + ' - ' +
                        dataHora.getDate() + "/" + 
                        (dataHora.getMonth() + 1) + "/" + 
                        dataHora.getFullYear()+ " " + 
                        dataHora.getHours() + ":" + 
                        dataHora.getMinutes() + ":" + 
                        dataHora.getSeconds() + ":" + 
                        dataHora.getMilliseconds() 

            const hash = Sha256.hash(texto); 
            document.getElementById('integration-api_key').value = hash 
            this.integration.api_key = hash
        },

        toggleModal() {
            this.modalActive = !this.modalActive;
            
            if (this.modalActive === false) {
                this.reset()
            }
            
            // Redefinir erros de validação de formulário
            this.$v.$reset();            
		},

        reset() {
            this.mode = 'save'
            this.isInsert = false
            this.integration = {}
            this.loadIntegrations()
        },

        saveIntegration() {
            // Se usuario não clicar no botão pra gerar token, o sistema gera antes de gravar!
            var apiKey = document.getElementById('integration-api_key').value;
            if (apiKey == "") {
                this.getGerarToken()
            } 

            if (this.validate()) {
                const method = this.integration.integracao_id ? 'put' : 'post'
                const id = this.integration.integracao_id ? `/${this.integration.integracao_id}` : ''
                const usuario = `/usuario/${this.$store.state.user.userid}`
                const url = `${baseApiUrl}/integracao${id}${usuario}`

                axios[method](url, this.integration)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)                

                this.toggleModal()
            }
        },
 
        removeIntegration(integration) {
            this.integration = { ...integration } 
            this.$refs.modalRemove.show(integration);
        },

        hideRemove() { 
            this.$refs.modalRemove.hide();
        },

        confirmeRemove() { 
            this.hideRemove();
            const id = this.integration.integracao_id
            axios.delete(`${baseApiUrl}/integracao/${id}`)
                 .then(resp => {
                     if (resp.data.status) {
                         this.$toasted.global.defaultSuccess()
                     } else 
                     {
                         this.$toasted.global.defaultError({ msg: resp.data.mensagem })
                     }
                     this.reset()
                 })
                 .catch(showError)
        }
    },

    watch: {
        page() {
            this.loadIntegrations()
        }
    },

    mounted() {
        this.loadIntegrations() 
        this.loadCompanies() 
        this.loadPlatforms()
    }    
}

</script>

<style scoped>
    .integrations-wrapper {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        gap: 20px;
    }

    .integrations-wrapper > div {
        padding: 20px;
        border: 1px solid var(--white-medium);
        border-radius: 10px;
    }

    .integration-card-header {
        display: grid;
        grid-template-columns: 50px calc(100% - 70px);
        gap: 20px;
    }

    .integration-card-header > div {
        display: grid;
        align-items: center;
    }

    .integration-card-header span {
        display: inline-block;
        width: 100%;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.2;
        white-space: nowrap;
    }

    .integration-card-header span:first-child {
        font-size: 16px;
        font-weight: 600;
    }

    .integration-card-header span:last-child {
        font-size: 13px;
        font-weight: 400;
    }

    .inactive-card :is(svg, img) {
        filter: grayscale(1);
    }
    
    .inactive-card {
        background-color: var(--white-light);
    }

    .integration-company-name {
        font-weight: 500;
        display: inline-block;
        margin: 10px 0;
    }
    
    .integration-buttons {
        display: flex;
        gap: 10px;
        width: 100%;
        margin-top: 10px
    }

    .integration-buttons > button {
        width: calc(50% - 5px);
        border: none;
        height: fit-content !important;
        padding: 5px 0 !important;
        transition: .3s;
        background-color: var(--red);
    }

    .integration-buttons > button:hover {
        filter: opacity(.8);
    }

    .integration-buttons > button:first-child {
        background-color: var(--bluee);
    }

    .integration-data span {
        display: inline-block;
        font-size: 14px
    }

    .title-integ {
        flex: 1;
        display: grid;
    }

    .error {
        border: 3px solid darkred;        
    }

    p {
        font-weight: 600;
        margin-bottom: 10px;
    }

    hr {
        border: 0;
        width: 100%;
        height: 1px;
        margin-top: 15px;
        margin-bottom: 20px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }   
    
    .mx-datepicker {
        position: relative;
        display: inline-block;
        width: 210px;
        font-size: 1rem;
    }

</style>